import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../api";

import { Label, FormFeedback } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            casillaUVT_id: null,
            casillaOTT_id: null,
            casillaInforme_id: null,
            casillaInformeConfirmacion_id: null,
            casillaSolicitarFactura_id: null,
            casillaSeparacionImputaciones_id: null,
            plantillaUVT_id: null,
            plantillaOTT_id: null,
            plantillaInforme_id: null,
            plantillaInformeConfirmacion_id: null,
            plantillaSolicitarFactura_id: null,
            plantillaSeparacionImputaciones_id: null,
            casillaImputacionesEnvioOTT_id: null,
            plantillaImputacionesEnvioOTT_id: null,
        };
    }

    static propTypes = {
        nav: PropTypes.any,
    }

    getData = () => {
        return {
            casillaUVT_id: this.state.casillaUVT_id,
            casillaOTT_id: this.state.casillaOTT_id,
            casillaInforme_id: this.state.casillaInforme_id,
            casillaInformeConfirmacion_id: this.state.casillaInformeConfirmacion_id,
            casillaSolicitarFactura_id: this.state.casillaSolicitarFactura_id,
            casillaSeparacionImputaciones_id: this.state.casillaSeparacionImputaciones_id,
            plantillaUVT_id: this.state.plantillaUVT_id,
            plantillaOTT_id: this.state.plantillaOTT_id,
            plantillaInforme_id: this.state.plantillaInforme_id,
            plantillaInformeConfirmacion_id: this.state.plantillaInformeConfirmacion_id,
            plantillaSolicitarFactura_id: this.state.plantillaSolicitarFactura_id,
            plantillaSeparacionImputaciones_id: this.state.plantillaSeparacionImputaciones_id,
            casillaImputacionesEnvioOTT_id: this.state.casillaImputacionesEnvioOTT_id,
            plantillaImputacionesEnvioOTT_id: this.state.plantillaImputacionesEnvioOTT_id,
        };
    }

    resetForm() {
        this.setState({
            casillaUVT_id: null,
            casillaOTT_id: null,
            casillaInforme_id: null,
            casillaInformeConfirmacion_id: null,
            casillaSolicitarFactura_id: null,
            casillaSeparacionImputaciones_id: null,
            plantillaUVT_id: null,
            plantillaOTT_id: null,
            plantillaInforme_id: null,
            plantillaInformeConfirmacion_id: null,
            plantillaSolicitarFactura_id: null,
            plantillaSeparacionImputaciones_id: null,
            casillaImputacionesEnvioOTT_id: null,
            plantillaImputacionesEnvioOTT_id: null,
        });
    }

    setSelects(data) {
        this.setState({
            casillaUVT_id: data.casillaUVT_id,
            casillaOTT_id: data.casillaOTT_id,
            casillaInforme_id: data.casillaInforme_id,
            casillaInformeConfirmacion_id: data.casillaInformeConfirmacion_id,
            casillaSolicitarFactura_id: data.casillaSolicitarFactura_id,
            casillaSeparacionImputaciones_id: data.casillaSeparacionImputaciones_id,
            plantillaUVT_id: data.plantillaUVT_id,
            plantillaOTT_id: data.plantillaOTT_id,
            plantillaInforme_id: data.plantillaInforme_id,
            plantillaInformeConfirmacion_id: data.plantillaInformeConfirmacion_id,
            plantillaSolicitarFactura_id: data.plantillaSolicitarFactura_id,
            plantillaSeparacionImputaciones_id: data.plantillaSeparacionImputaciones_id,
            casillaImputacionesEnvioOTT_id: data.casillaImputacionesEnvioOTT_id,
            plantillaImputacionesEnvioOTT_id: data.plantillaImputacionesEnvioOTT_id,
        });
    }

    renderSelector(label, fieldName, value, url, nombreField) {
        return (
            <div className="ui-field">
                <Label>{label}</Label>
                <ParadigmaAsyncSeeker
                    clearable={true}
                    nombreField={nombreField}
                    url={url}
                    fieldName={fieldName}
                    value={value}
                    onChange={(data) => this.setState({ [fieldName]: (data ? data.pk : null) })}
                />
                <FormFeedback className="col-12"></FormFeedback>
            </div>
        );
    }

    renderEmailBlock(title, casillaLabel, casillaField, plantillaLabel, plantillaField) {
        return (
            <section className="ui-section-block">
                <p className="ui-section-label">{title}</p>
                <div className="ui-row-2">
                    {this.renderSelector(
                        casillaLabel,
                        casillaField,
                        this.state[casillaField],
                        api.email.casillas.select
                    )}
                    {this.renderSelector(
                        plantillaLabel,
                        plantillaField,
                        this.state[plantillaField],
                        api.email.plantillas.select,
                        "descripcion"
                    )}
                </div>
            </section>
        );
    }

    renderEmailBlocks() {
        const blocks = [
            { title: "UVT", casillaLabel: "Casilla UVT", casillaField: "casillaUVT_id", plantillaLabel: "Plantilla UVT", plantillaField: "plantillaUVT_id" },
            { title: "OTT", casillaLabel: "Casilla OTT", casillaField: "casillaOTT_id", plantillaLabel: "Plantilla OTT", plantillaField: "plantillaOTT_id" },
            { title: "Informes", casillaLabel: "Casilla Informes", casillaField: "casillaInforme_id", plantillaLabel: "Plantilla Informes", plantillaField: "plantillaInforme_id" },
            { title: "Informes - Confirmación", casillaLabel: "Casilla Informes (Confirmación)", casillaField: "casillaInformeConfirmacion_id", plantillaLabel: "Plantilla Informes (Confirmación)", plantillaField: "plantillaInformeConfirmacion_id" },
            { title: "Solicitud de factura", casillaLabel: "Casilla Solicitar Factura", casillaField: "casillaSolicitarFactura_id", plantillaLabel: "Plantilla Solicitar Factura", plantillaField: "plantillaSolicitarFactura_id" },
            { title: "Imputaciones", casillaLabel: "Casilla Imputaciones", casillaField: "casillaSeparacionImputaciones_id", plantillaLabel: "Plantilla Imputaciones", plantillaField: "plantillaSeparacionImputaciones_id" },
            { title: "Imputaciones - Envío OTT", casillaLabel: "Casilla Imputaciones - Envío OTT", casillaField: "casillaImputacionesEnvioOTT_id", plantillaLabel: "Plantilla Imputaciones - Envío OTT", plantillaField: "plantillaImputacionesEnvioOTT_id" },
        ];

        return blocks.map((block, i) => (
            <React.Fragment key={block.title}>
                {i > 0 && <div className="ui-divider" />}
                {this.renderEmailBlock(block.title, block.casillaLabel, block.casillaField, block.plantillaLabel, block.plantillaField)}
            </React.Fragment>
        ));
    }

    render() {
        return (
            <ParadigmaModal
                navButton={(this.props.nav ? true : false)}
                nav={this.props.nav}
                getUrl={api.configuracion.edit}
                postUrl={api.configuracion.edit}
                onPreSubmit={this.getData}
                id={this.props.id}
                successMessage={"La Configuración ha sido editada con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Configuración General"}
                buttonTitle={"Editar"}
                buttonIcon={"ti ti-edit"}
                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetForm()}
                className={"ui-modal-dialog ui-modal-lg"}
            >
                <div className="ui-form">
                    <div className="ui-section-stack">
                        {this.renderEmailBlocks()}
                    </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Configuraciones/Edit.js